import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertTypes } from 'src/app/models/enums/inline-alert';
import { ConfirmModalActionsVm } from 'src/app/models/modal-actions/confirm-modal-action';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import * as strings from './calc-max-content-modal.component.strings';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalIconsComponent } from '../modal-icons/modal-icons.component';

@Component({
    selector: 'app-calc-max-content-modal',
    templateUrl: './calc-max-content-modal.component.html',
    styleUrls: ['./calc-max-content-modal.component.scss'],
    imports: [BaseModalComponent, ModalIconsComponent]
})
export class CalcMaxContentModalComponent implements OnInit, OnDestroy {
    public modalActions: ConfirmModalActionsVm = new ConfirmModalActionsVm();
    public AlertTypes = AlertTypes;
    public s = strings;

    @Input() set inputs(value: ConfirmModalActionsVm) {
        this.modalActions = value;
    }

    constructor(
        private googleTagManagerService: GoogleTagManagerService,
        public activeModal: NgbActiveModal,
    ) { }

    ngOnDestroy(): void {
        this.googleTagManagerService.trackAction(this.s.GoogleTagManagerEvent, this.s.GoogleTagManagerPopUpCloseAction, undefined, this.s.GoogleTagManagerName);
    }

    ngOnInit(): void {
        this.googleTagManagerService.trackAction(this.s.GoogleTagManagerEvent, this.s.GoogleTagManagerPopUpOpenAction, undefined, this.s.GoogleTagManagerName);
    }

    public onBtnClick(){
        this.modalActions.customAction();
    }
}
